import './AssessBackground.scss'
import React, { Component } from 'react'
import { Background } from '../lib'

const backgrounds = [
  require('../assets/assess-bkg-01.png'),
  require('../assets/assess-bkg-02.png'),
  require('../assets/assess-bkg-03.png'),
  require('../assets/assess-bkg-04.png'),
  require('../assets/assess-bkg-05.png'),
  require('../assets/assess-bkg-06.png'),
  require('../assets/assess-bkg-07.png')
]

class AssessBackground extends Component {
  constructor(props) {
    super(props)
    this.state = {
      prevIndex: null
    }
  }

  componentWillReceiveProps(nextProps) {
    const nextIndex = Math.floor(nextProps.progress * backgrounds.length)
    const prevIndex = Math.floor(this.props.progress * backgrounds.length)
    if (nextIndex !== prevIndex) {
      this.setState({ prevIndex })
    }
  }

  render() {
    const index = Math.floor(this.props.progress * backgrounds.length)
    const { prevIndex } = this.state
    return (
      <div className='AssessBackground'>
        <Background
          key={index}
          src={backgrounds[index]}
          className='AssessBackground_active'
        />
        <Background
          key={prevIndex}
          src={backgrounds[prevIndex]}
          className='AssessBackground_prev'
        />
      </div>
    )
  }
}

export default AssessBackground



// WEBPACK FOOTER //
// ./src/assess/AssessBackground.js